import { useState } from 'react'

import { useRouter } from 'next/router'

import { validateSimpleString } from '@/utils/validations'

type TouchedProps = {
  [key: string]: boolean
}

type FocusProps = {
  [key: string]: boolean
}

export const useInputValidation = () => {
  const [touched, setTouched] = useState<TouchedProps>({} as TouchedProps)
  const [focus, setFocus] = useState<FocusProps>({} as FocusProps)
  const router = useRouter()

  const handleFocus = (field: string) => setFocus({ ...focus, [field]: true })

  const handleBlur = (field: string) =>
    setTouched({ ...touched, [field]: true })

  const handleTouched = (field: string) =>
    setTouched({ ...touched, [field]: false })

  const handleErrorMessage = (
    field: string,
    value: string,
    customValidate?: (value: string) => boolean,
    customErrorMessage?: string,
    required = true,
  ) => {
    if (touched[field]) {
      if (!validateSimpleString(value) && required) {
        if (router.locale !== 'pt-BR') {
          return 'Required'
        }
        return 'Campo obrigatório'
      }
      if (customValidate && !customValidate(value) && value)
        return customErrorMessage
    }
    return null
  }

  const clearTouched = () => setTouched({})
  const clearFocus = () => setFocus({})

  return {
    touched,
    setTouched,
    handleBlur,
    handleTouched,
    handleErrorMessage,
    handleFocus,
    focus,
    clearTouched,
    clearFocus,
  }
}
